import React from "react";
import { DeviceDowntimeLoaderTemplate } from "../../../../themes/default/application/device-settings/components/content-loader";

function DeviceDowntimeLoader(props) {
    return <DeviceDowntimeLoaderTemplate {...props} />;
}

export default DeviceDowntimeLoader;
